import { useState } from "react"
import AuthCode from 'react-auth-code-input'
import { useTranslation } from 'react-i18next'
import styles from './PinCode.module.scss'
import eye from 'assets/icons/eye.png'
import hidden from 'assets/icons/hidden.png'

const PinCode = ({ setPinCode, passwordVisible }) => {
  const { t } = useTranslation('common')
  const [showPassword, setShowPassword] = useState(false)
  const [isError, setIsError] = useState(false)

  const togglePasswordVisibility = () => {
    setShowPassword((v) => !v)
  }

  const handleOnChange = (value) => {
    setIsError(value.length < 4)
    if (value.length === 4) {
      setPinCode(value)
    }
  }

  return (
    <div className={styles.wrap}>
      <button
        type="button"
        className={styles.show__password}
        onClick={togglePasswordVisibility}
        aria-label={
          showPassword
            ? t('auth.hide_pin', 'Скрыть ПИН')
            : t('auth.show_pin', 'Показать ПИН')
        }
      >
        <img src={showPassword ? hidden : eye} alt="" />
      </button>

      <AuthCode
        length={4}
        onChange={handleOnChange}
        allowedCharacters={'numeric'}
        isPassword={showPassword ? passwordVisible : true}
        containerClassName={styles.container}
        inputClassName={isError ? `${styles.inputs} ${styles.error}` : styles.inputs}
        autoComplete="off"
      />
    </div>
  )
}

export default PinCode
